/*
  Behaviour for `snippets/card-product-custom.liquid`.

  This used to live in an inline <script> inside the snippet itself, which meant
  it was re-emitted once per card and — more importantly — never ran at all for
  cards injected through AJAX (product recommendations), because scripts set via
  innerHTML are not executed. Cards then kept every colourway's images stacked in
  one strip and showed whichever frame the stale transform happened to land on.

  It is now loaded once from layout/theme.liquid and exposes
  `window.initProductCards(scope)` so any section that injects cards can wire
  them up explicitly.
*/
(function () {
  if (window.initProductCards) return;

  var $ = window.jQuery;
  if (!$) return;

  var cloneSeq = 0;

  function toElement(scope) {
    if (!scope) return document;
    if (scope.jquery) return scope[0] || document;
    return scope;
  }

  function getSelectedColor($card) {
    var $checked = $card.find('input[type="radio"]:checked');
    if (!$checked.length) $checked = $card.find('input[type="radio"]').first();
    return ($checked.data('color') || '').toLowerCase().trim();
  }

  // A slide's colour comes from its image's alt text (see card-product-custom
  // .liquid), so it only lines up with the swatch when the merchant named the
  // alt after the colourway. Products that kept the default alt (the product
  // title) match nothing.
  function hasSlideForColor($slider, color) {
    var slides = $slider[0].querySelectorAll('.pcc-slide');
    for (var i = 0; i < slides.length; i++) {
      if ((slides[i].getAttribute('data-color') || '').toLowerCase().trim() === color) {
        return true;
      }
    }
    return false;
  }

  // Restrict the slider to only the selected color's images.
  // Filtering (vs. bouncing back) means swipe can't reach other colors,
  // and slick rebuilds the pagination dots for just this color.
  function filterToColor($slider, color) {
    if (!$slider.hasClass('slick-initialized')) return;
    $slider.slick('slickUnfilter');
    // Filtering to an empty set leaves slick with a zero-width track, i.e. a
    // blank card. When no image is tagged with this colour, show them all
    // rather than nothing.
    if (color && hasSlideForColor($slider, color)) {
      // slick wraps each .pcc-slide in a .slick-slide, so data-color lives on the
      // inner element — match via a function that reads it.
      $slider.slick('slickFilter', function () {
        var el = (this.querySelector && this.querySelector('.pcc-slide')) || this;
        return (el.getAttribute('data-color') || '').toLowerCase().trim() === color;
      });
    }
    $slider.slick('slickGoTo', 0, true);
  }

  // An outer carousel (e.g. The Layering Edit) clones its <li> slides. When it
  // does so *after* the inner image slider was initialised, the clone inherits
  // slick's markup and classes but no live instance — leaving a dead strip that
  // renders an arbitrary frame. Tear that markup back down to the bare slides so
  // the strip can be initialised from scratch.
  function resetStaleSlider($slider) {
    var el = $slider[0];
    if (!el.classList.contains('slick-initialized')) return;
    if (el.slick) return; // healthy instance — leave it alone

    var $slides = $slider.find('.pcc-slide').detach();
    $slides
      .removeClass('slick-slide slick-current slick-active slick-cloned')
      .removeAttr('style aria-hidden tabindex data-slick-index role');

    $slider
      .removeClass('slick-initialized slick-slider slick-dotted')
      .removeAttr('role aria-label tabindex')
      .empty()
      .append($slides);
  }

  // Slick blanks the `id` of every element inside a cloned slide but leaves the
  // matching `label[for=...]` pointing at the original card. A click on a clone's
  // swatch therefore toggles a radio belonging to a different card somewhere else
  // in the track — which is why swatches looked inert. Re-key each clone so its
  // input/label pairs and its radio group are self-contained.
  function rewireClonedCards(scope) {
    var root = toElement(scope);
    if (!root.querySelectorAll) return;

    var clones = root.querySelectorAll('.slick-cloned');
    Array.prototype.forEach.call(clones, function (clone) {
      if (clone.getAttribute('data-pcc-rewired')) return;
      clone.setAttribute('data-pcc-rewired', '1');

      var suffix = '--pcc-clone-' + ++cloneSeq;
      var swatches = clone.querySelectorAll('.collection-product-card__swatch');

      Array.prototype.forEach.call(swatches, function (swatch) {
        var input = swatch.querySelector('input[type="radio"]');
        var label = swatch.querySelector('label[for]');
        if (!input || !label) return;

        var newId = label.getAttribute('for') + suffix;
        input.id = newId;
        label.setAttribute('for', newId);

        // Clones keep the original `name`, so the browser treats clone and
        // original as a single radio group and the offscreen clone steals the
        // selection — leaving the visible card with no active ring.
        if (input.name && input.name.indexOf(suffix) === -1) {
          input.name += suffix;
        }

        // jQuery's clone() copies the `checked` attribute but not the live
        // property, which is what CSS `input:checked + label` reads.
        input.checked = input.hasAttribute('checked');
      });
    });
  }

  // Building a carousel detaches and re-inserts the slides, which wipes the live
  // `checked` property off the swatch radios — the HTML attribute survives, but
  // CSS `input:checked + label` and getSelectedColor() both read the property.
  // Re-apply the default, but only for groups where nothing is checked, so a
  // shopper's own pick is never overridden (this also runs on every breakpoint).
  function restoreSwatchSelection(scope) {
    var root = toElement(scope);
    if (!root.querySelectorAll) return;

    var groups = root.querySelectorAll('.collection-product-card__variants');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.querySelector('input[type="radio"]:checked')) return;
      var def = group.querySelector('input[type="radio"][checked]')
        || group.querySelector('input[type="radio"]');
      if (def) def.checked = true;
    });
  }

  function initProductSliders(scope) {
    var $scope = $(toElement(scope));

    $scope.find('.slider-img').each(function () {
      var $slider = $(this);

      // One malformed card must not stop the rest of the grid from wiring up.
      try {
        resetStaleSlider($slider);

        // Already wired: just re-measure. A strip built while its card was
        // still laid out by an outer carousel keeps those slide widths after
        // the carousel is torn down, leaving the next image peeking in.
        if ($slider.hasClass('slick-initialized')) {
          if (this.slick) $slider.slick('setPosition');
          return;
        }

        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: false,
          dots: true,
          adaptiveHeight: true
        });

        // On init: keep only the selected color's images in the slider
        filterToColor($slider, getSelectedColor($slider.closest('.card-product-custom-div')));
      } catch (e) {
        console.error('[product-card-custom] slider init failed', e, this);
      }
    });

    // Arrow buttons — the slider only holds this color's images, so plain prev/next
    $scope.find('.carousel-prev-affiliate').off('click.pcc').on('click.pcc', function (e) {
      e.preventDefault();
      var $slider = $(this).closest('.card-product-custom-div').find('.slider-img');
      if ($slider.hasClass('slick-initialized')) $slider.slick('slickPrev');
    });

    $scope.find('.carousel-next-affiliate').off('click.pcc').on('click.pcc', function (e) {
      e.preventDefault();
      var $slider = $(this).closest('.card-product-custom-div').find('.slider-img');
      if ($slider.hasClass('slick-initialized')) $slider.slick('slickNext');
    });
  }

  // Cards rendered without the image strip: show the first image of the
  // selected colour and hide the rest.
  function initNonGridCards(scope) {
    $(toElement(scope)).find('.non-grid-media').each(function () {
      var $wrap = $(this);
      var color = getSelectedColor($wrap.closest('.card-product-custom-div'));
      var $imgs = $wrap.find('.pcc-hover-img');
      var $colorImgs = $imgs.filter(function () {
        return ($(this).data('color') || '').toLowerCase().trim() === color;
      });

      $imgs.hide();
      if ($colorImgs.length) $colorImgs.first().show();
      else $imgs.first().show();
    });
  }

  function showNonGridImage($card, color, index) {
    var $wrap = $card.find('.non-grid-media');
    if (!$wrap.length) return;

    var $imgs = $wrap.find('.pcc-hover-img');
    var $colorImgs = $imgs.filter(function () {
      return ($(this).data('color') || '').toLowerCase().trim() === color;
    });

    $imgs.hide();
    if ($colorImgs.length) $colorImgs.eq(Math.min(index, $colorImgs.length - 1)).show();
    else $imgs.eq(Math.min(index, $imgs.length - 1)).show();
  }

  // Order matters: clones must be re-keyed and the default swatch restored
  // before the image strips are built, because the strip is filtered down to
  // whichever colour is currently checked.
  window.initProductCards = function (scope) {
    rewireClonedCards(scope);
    restoreSwatchSelection(scope);
    initProductSliders(scope);
    initNonGridCards(scope);
  };

  // Delegated handlers — bound once, so they also cover cards injected later.
  $(document)
    .on('mouseenter.pcc', '.card-product-custom-div', function () {
      var $card = $(this);
      var $slider = $card.find('.slider-img');
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickGoTo', 1, true);
        return;
      }
      showNonGridImage($card, getSelectedColor($card), 1);
    })
    .on('mouseleave.pcc', '.card-product-custom-div', function () {
      var $card = $(this);
      var $slider = $card.find('.slider-img');
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickGoTo', 0, true);
        return;
      }
      showNonGridImage($card, getSelectedColor($card), 0);
    })
    .on('change.pcc', '.card-product-custom-div input[type="radio"]', function () {
      var $card = $(this).closest('.card-product-custom-div');
      var color = ($(this).data('color') || '').toLowerCase().trim();
      var $slider = $card.find('.slider-img');

      if ($slider.hasClass('slick-initialized')) {
        filterToColor($slider, color);
        return;
      }
      showNonGridImage($card, color, 0);
    });

  $(function () {
    window.initProductCards(document);
  });

  document.addEventListener('products:loaded', function (event) {
    var detail = event.detail || {};
    var items = detail.items || [];
    var scope = (items[0] && items[0].parentElement) || document;
    window.initProductCards(scope);
  });

  document.addEventListener('shopify:section:load', function (event) {
    window.initProductCards(event.target || document);
  });
})();
